import { useState, useEffect, useRef } from "react";
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import ModalConfirm from '../ModalConfirm';
import { useNavigate } from "react-router-dom";
import Inventario from "./Inventario";
import Empleados from "./Empleados";
import Pedidos from "./Pedidos";
import ArticulosMenu from "./ArticulosMenu";

const Restaurantes = () => {
    
    const [restaurantes, setRestaurantes] = useState([]);
    const [nuevoRestaurante, setNuevoRestaurante] = useState({
        nombre: "", direccion: "", telefono: "", correo_electronico: "", rfc: "",
        pagina: "", facebook: "", estatus: 1
    });
    const [editandoRestauranteId, setEditandoRestauranteId] = useState(null);
    const [restauranteEditado, setRestauranteEditado] = useState({
        nombre: "", direccion: "", telefono: "", correo_electronico: "", rfc: "",
        pagina: "", facebook: "", estatus: 1
    });
    const [restauranteSeleccionado, setRestauranteSeleccionado] = useState(null);
    const [mensajeExito, setMensajeExito] = useState(false);
    const [inventario, setInventario] = useState([]);
    const [mostrarInventario, setMostrarInventario] = useState(false);
    const [mostrarEmpleados, setMostrarEmpleados] = useState(false);
    const [busqueda, setBusqueda] = useState(""); // Nuevo estado para la barra de búsqueda
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [restauranteAEliminar, setRestauranteAEliminar] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false); // Controla la visibilidad del formulario
    const [componenteActivo, setComponenteActivo] = useState(null); // Para rastrear qué componente está activo: 'inventario' o 'empleados'

    const formularioRef = useRef(null);
    const inputRef = useRef(null);
    const navigate = useNavigate(); // Para redirigir en logout

    useEffect(() => {
        obtenerRestaurantes();
    }, []);

  
    // Obtener lista de restaurantes
    const obtenerRestaurantes = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "restaurantes"
            });
            setRestaurantes(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    // Función para manejar el cambio en la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar los restaurantes en función del término de búsqueda
    const restaurantesFiltrados = restaurantes.filter((restaurante) => {
        return (
            (restaurante.nombre || "").toLowerCase().includes(busqueda) ||
            (restaurante.direccion || "").toLowerCase().includes(busqueda) ||
            (restaurante.telefono || "").toLowerCase().includes(busqueda) ||
            (restaurante.correo_electronico || "").toLowerCase().includes(busqueda) ||
            (restaurante.correo_electronico || "").toLowerCase().includes(busqueda) ||
            (restaurante.rfc || "").toLowerCase().includes(busqueda)
        );
    });



    // Función para agregar un nuevo restaurante
    const handleAgregarRestaurante = async (e) => {
        e.preventDefault();

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "restaurantes",
                ...nuevoRestaurante
            });

            setNuevoRestaurante({
                nombre: "", direccion: "", telefono: "", correo_electronico: "", rfc: "",
                pagina: "", facebook: "", estatus: 1
            });
            setMensajeExito(true);
            setTimeout(() => setMensajeExito(false), 3000);
            obtenerRestaurantes();
            setMostrarFormulario(false); // Esconde el formulario tras agregar el restaurante
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar un restaurante existente
    const editarRestaurante = (idRestaurante, restauranteActual) => {
        setEditandoRestauranteId(idRestaurante);
        setRestauranteEditado(restauranteActual);
        setRestauranteSeleccionado(idRestaurante);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.setSelectionRange(0, 0);
            }
        }, 0);
    };


    // Función para guardar los cambios del restaurante editado
    const guardarRestauranteEditado = async (idRestaurante) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "restaurantes",
                id: idRestaurante,
                ...restauranteEditado
            });

            setEditandoRestauranteId(null);
            setRestauranteSeleccionado(null);
            obtenerRestaurantes();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para confirmar la eliminación de un restaurante
    const confirmarEliminarRestaurante = (idRestaurante) => {
        setShowConfirmModal(true);
        setRestauranteAEliminar(idRestaurante);
    };

    const ejecutarEliminarRestaurante = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "restaurantes",
                id: restauranteAEliminar
            });

            setShowConfirmModal(false);
            obtenerRestaurantes();
        } catch (error) {
            console.log(error);
        }
    };

    const cancelarSeleccion = () => {
        setRestauranteSeleccionado(null);
        setEditandoRestauranteId(null);
        setComponenteActivo(null); // Reseteamos el componente activo cuando se cancela


    };

    const handleMostrarFormulario = () => {
        setMostrarFormulario(true);
        setTimeout(() => {
            formularioRef.current.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Un pequeño retraso para asegurar que el formulario esté visible antes de hacer scroll
    };

    return (
        <>
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este restaurante?"
                onConfirm={ejecutarEliminarRestaurante}
                onCancel={() => setShowConfirmModal(false)}
            />

            
                <>
                    <Dasboard  /> {/* Mostrar el dashboard */}

                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">Restaurantes</h2>

                                {/* Barra de búsqueda */}
                                <input
                                    type="text"
                                    placeholder="Buscar transacción..."
                                    value={busqueda}
                                    onChange={handleBusqueda}
                                    className="border rounded-lg p-2 mb-4 w-full"
                                />

                                <ul>
                                    {restaurantesFiltrados.map((restaurante) => (
                                        <li key={restaurante.id} className="border-4 p-4 rounded-lg mb-4 cursor-pointer"
                                            onClick={() => setRestauranteSeleccionado(restaurante.id)}>

                                            <div className="relative">
                                                {restauranteSeleccionado === restaurante.id && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            cancelarSeleccion(); // O la acción que desees para cerrar la información
                                                        }}
                                                        className="absolute top-[-1rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                                {editandoRestauranteId === restaurante.id ? (

                                                    <div className="flex flex-col">
                                                        <h3 className=" font-semibold">Nombre:</h3>
                                                        <input
                                                            type="text"
                                                            ref={inputRef}
                                                            value={restauranteEditado.nombre}
                                                            onChange={(e) => setRestauranteEditado({ ...restauranteEditado, nombre: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={50}
                                                        />

                                                        <h3 className=" font-semibold">Dirección:</h3>
                                                        <input
                                                            type="text"
                                                            value={restauranteEditado.direccion}
                                                            onChange={(e) => setRestauranteEditado({ ...restauranteEditado, direccion: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={50}
                                                        />

                                                        <h3 className="font-semibold">Teléfono:</h3>
                                                        <input
                                                            type="text"
                                                            value={restauranteEditado.telefono}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permite solo números y un máximo de 10 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 10) {
                                                                    setRestauranteEditado({ ...restauranteEditado, telefono: value });
                                                                }
                                                            }}
                                                            placeholder="Teléfono"
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={10}
                                                        />


                                                        <h3 className=" font-semibold">Correo Electrónico:</h3>
                                                        <input
                                                            type="email"
                                                            value={restauranteEditado.correo_electronico}
                                                            onChange={(e) => setRestauranteEditado({ ...restauranteEditado, correo_electronico: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={50}
                                                        />

                                                        <h3 className=" font-semibold ">RFC:</h3>
                                                        <input
                                                            type="text"
                                                            value={restauranteEditado.rfc}
                                                            onChange={(e) => setRestauranteEditado({ ...restauranteEditado, rfc: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={20}
                                                        />

                                                        <h3 className=" font-semibold">Página Web:</h3>                                                        <input
                                                            type="text"
                                                            value={restauranteEditado.pagina}
                                                            onChange={(e) => setRestauranteEditado({ ...restauranteEditado, pagina: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={30}
                                                        />

                                                        <h3 className=" font-semibold">Facebook:</h3>
                                                        <input
                                                            type="text"
                                                            value={restauranteEditado.facebook}
                                                            onChange={(e) => setRestauranteEditado({ ...restauranteEditado, facebook: e.target.value })}
                                                            className="border rounded-lg p-2 mb-2"
                                                            maxLength={50}
                                                        />

                                                        <div className="flex mt-4">
                                                            <button onClick={() => guardarRestauranteEditado(restaurante.id)}
                                                                className="bg-green-500 text-white rounded px-2 py-1 mr-2 w-40">Guardar</button>
                                                            <button onClick={() => setEditandoRestauranteId(null)}
                                                                className="bg-gray-500 text-white rounded px-2 py-1 w-40">Cancelar</button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col">
                                                        <span><strong>Nombre:</strong> {restaurante.nombre}</span>
                                                        <span><strong>Dirección:</strong> {restaurante.direccion}</span>
                                                        <span><strong>Teléfono:</strong> {restaurante.telefono}</span>
                                                        <span><strong>Correo Electrónico:</strong> {restaurante.correo_electronico}</span>
                                                        <span><strong>RFC:</strong> {restaurante.rfc}</span>
                                                        <span><strong>Página Web:</strong> {restaurante.pagina}</span>
                                                        <span><strong>Facebook:</strong> {restaurante.facebook}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {restauranteSeleccionado === restaurante.id && !editandoRestauranteId && (
                                                <>
                                                    <div className="flex items-center ">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                editarRestaurante(restaurante.id, restaurante);
                                                            }}
                                                            className="bg-gray-500 text-white rounded px-2 py-1 mr-2 hover:bg-gray-400"
                                                        >
                                                            Editar Restaurante
                                                        </button>


                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                confirmarEliminarRestaurante(restaurante.id);
                                                            }}
                                                            className="bg-red-600 text-white rounded px-2 py-1 mr-2 hover:bg-red-500"
                                                        >
                                                            Borrar Restaurante
                                                        </button>

                                                    </div>

                                                    <div className="mt-12 space-y-2">
                                                        <>
                                                            {/* Botón para Mostrar Inventario */}
                                                            <button
                                                                onClick={() => setComponenteActivo('inventario')}
                                                                className={`px-4 py-2 rounded mr-2 ${componenteActivo === 'inventario' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Inventario
                                                            </button>

                                                            {/* Botón para Mostrar Empleados */}
                                                            <button
                                                                onClick={() => setComponenteActivo('empleados')}
                                                                className={`px-4 py-2 rounded mr-2 ${componenteActivo === 'empleados' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Empleados
                                                            </button>

                                                            {/* Botón para Mostrar Articulos Menu */}
                                                            <button
                                                                onClick={() => setComponenteActivo('articulosmenu')}
                                                                className={`px-4 py-2 rounded mr-2 ${componenteActivo === 'articulosmenu' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Menu
                                                            </button>

                                                            {/* Botón para Mostrar Pedidos */}
                                                            <button
                                                                onClick={() => setComponenteActivo('pedidos')}
                                                                className={`px-4 py-2 rounded ${componenteActivo === 'pedidos' ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'}`}
                                                            >
                                                                Pedidos
                                                            </button>


                                                            {/* Mostrar el componente seleccionado */}
                                                            {componenteActivo === 'inventario' && <Inventario restauranteId={restaurante.id} />}

                                                            {componenteActivo === 'empleados' && <Empleados restauranteId={restaurante.id} />}

                                                            {componenteActivo === 'pedidos' && <Pedidos restauranteId={restaurante.id} />}

                                                            {componenteActivo === 'articulosmenu' && <ArticulosMenu restauranteId={restaurante.id} />}
                                                        </>
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                                {/* Botón para mostrar el formulario */}
                                {!mostrarFormulario && (
                                    <div className="flex ">
                                        <button
                                            onClick={handleMostrarFormulario}
                                            className="bg-blue-500 text-white rounded px-4 py-2 mb-4 hover:bg-blue-400"
                                        >
                                            Agregar nuevo restaurante
                                        </button>

                                    </div>
                                )}

                                {/* Mostrar formulario si el estado "mostrarFormulario" es verdadero */}
                                {mostrarFormulario && (
                                    <form onSubmit={handleAgregarRestaurante} className="flex flex-col space-y-4 mt-4" ref={formularioRef}>
                                        <h3 className="text-lg font-semibold">Agregar nuevo Restaurante</h3>
                                        <input
                                            type="text"
                                            value={nuevoRestaurante.nombre}
                                            onChange={(e) => setNuevoRestaurante({ ...nuevoRestaurante, nombre: e.target.value })}
                                            placeholder="Nombre"
                                            className="border rounded-lg p-2"
                                            maxLength={50}
                                        />
                                        <input
                                            type="text"
                                            value={nuevoRestaurante.direccion}
                                            onChange={(e) => setNuevoRestaurante({ ...nuevoRestaurante, direccion: e.target.value })}
                                            placeholder="Dirección"
                                            className="border rounded-lg p-2"
                                            maxLength={50}
                                        />
                                        <input
                                            type="text"
                                            value={nuevoRestaurante.telefono}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Solo permite números y un máximo de 10 caracteres
                                                if (/^\d*$/.test(value) && value.length <= 10) {
                                                    setNuevoRestaurante({ ...nuevoRestaurante, telefono: value });
                                                }
                                            }}
                                            placeholder="Teléfono"
                                            className="border rounded-lg p-2"
                                            maxLength={10}
                                        />

                                        <input
                                            type="email"
                                            value={nuevoRestaurante.correo_electronico}
                                            onChange={(e) => setNuevoRestaurante({ ...nuevoRestaurante, correo_electronico: e.target.value })}
                                            placeholder="Correo Electrónico"
                                            className="border rounded-lg p-2"
                                            maxLength={50}
                                        />
                                        <input
                                            type="text"
                                            value={nuevoRestaurante.rfc}
                                            onChange={(e) => setNuevoRestaurante({ ...nuevoRestaurante, rfc: e.target.value })}
                                            placeholder="RFC"
                                            className="border rounded-lg p-2"
                                            maxLength={20}
                                        />
                                        <input
                                            type="text"
                                            value={nuevoRestaurante.pagina}
                                            onChange={(e) => setNuevoRestaurante({ ...nuevoRestaurante, pagina: e.target.value })}
                                            placeholder="Página Web"
                                            className="border rounded-lg p-2"
                                            maxLength={30}
                                        />
                                        <input
                                            type="text"
                                            value={nuevoRestaurante.facebook}
                                            onChange={(e) => setNuevoRestaurante({ ...nuevoRestaurante, facebook: e.target.value })}
                                            placeholder="Facebook"
                                            className="border rounded-lg p-2"
                                            maxLength={50}
                                        />
                                        <div className="flex space-x-4">
                                            <button type="submit" className="bg-green-500 rounded text-white px-4 py-2">
                                                Agregar Restaurante
                                            </button>
                                            {/* Botón de cancelar */}
                                            <button
                                                type="button"
                                                onClick={() => setMostrarFormulario(false)}
                                                className="bg-gray-500 text-white rounded px-4 py-2"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </form>
                                )}

                                {mensajeExito && (
                                    <p className="text-pink-500 mt-2">Restaurante agregado exitosamente</p>
                                )}
                            </div>
                        </div>
                    </main>
                </>
            
        </>
    );
};

export default Restaurantes;
